import { render, staticRenderFns } from "./RegistroFotoCuip.vue?vue&type=template&id=baf2812a"
import script from "./RegistroFotoCuip.vue?vue&type=script&lang=js"
export * from "./RegistroFotoCuip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports